import { Amplify } from 'aws-amplify';
/*
 * Registers the handler that finishes a signInWithRedirect callback.
 *
 * Amplify only attaches it as an import side effect, and the code that performs the
 * token exchange is reachable only from the sign-in APIs — which live in the
 * code-split sign-in modal. So on returning from Google the page had the listener
 * but not the exchange: no request to /oauth2/token, no error, and ?code= left
 * sitting in the URL. Opening the sign-in dialog pulled that chunk in and the
 * pending flow then completed, which is why signing in appeared to need two
 * attempts. This module is imported eagerly from src/index.tsx, so importing the
 * listener here puts the whole completion path in the initial bundle.
 *
 * Must stay a bare side-effect import: there is no binding to use, and dropping it
 * silently breaks federated sign-in.
 */
import 'aws-amplify/auth/enable-oauth-listener';

/**
 * Configures Amplify Auth as an import side effect.
 *
 * This used to live at module scope in LocalingosAuthenticator.tsx, which worked
 * only because that component — and with it the whole Amplify UI and Cloudscape
 * form stack — was imported eagerly on every page load. Now that the sign-in UI
 * is code-split behind a dynamic import, the configuration has to be somewhere
 * that is still loaded up front: `UserContext` calls `fetchAuthSession()` on mount
 * and would throw without it.
 *
 * Imported for its side effect from src/index.tsx, before the app renders.
 */
Amplify.configure({
    Auth: {
        Cognito: {
            userPoolId: process.env.REACT_APP_USER_POOL_ID!,
            userPoolClientId: process.env.REACT_APP_USER_POOL_CLIENT_ID!,
            loginWith: {
                email: true,
                username: false,
                oauth: {
                    domain: process.env.REACT_APP_AUTH_DOMAIN!,
                    scopes: ['openid', 'email', 'profile'],
                    redirectSignIn: [process.env.REACT_APP_REDIRECT_SIGN_IN!],
                    redirectSignOut: [process.env.REACT_APP_REDIRECT_SIGN_OUT!],
                    responseType: 'code',
                    providers: ['Google', { custom: 'Cognito' }]
                },
            },
        },
    },
});
